// extracted by mini-css-extract-plugin
export default {"height400":"MiDia_height400__OUYqZ","liMiDia":"MiDia_liMiDia__CGFo-","timelineCard":"MiDia_timelineCard__iM9RT"};